export default "__VITE_ASSET__c52e4346__"